import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { useParams, Link } from 'react-router-dom';
import './Components/ExamInstruction.css';
import useBlockBackNavigation from "../src/hooks/useBlockBackNavigation.js";
const ExamInstructions = () => {
  useBlockBackNavigation("Back navigation is disabled after submission.");
  const { attemptId } = useParams(); // get attemptId from URL
  const [examData, setExamData] = useState(null);
  const [timeLeft, setTimeLeft] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  
  // Use the correct API base URL (matches your C# backend)
const API_BASE = process.env.REACT_APP_API_BASE_URL;

  useEffect(() => {
    const fetchExamDetails = async () => {
      try {
        if (!attemptId || attemptId === "undefined") {
          throw new Error("No valid attemptId provided");
        }

        console.log("Fetching exam details for attemptId:", attemptId);
        
        // Convert attemptId to number (API expects integer)
        const attemptIdNum = parseInt(attemptId, 10);
        if (isNaN(attemptIdNum)) {
          throw new Error("Invalid attempt ID format");
        }

        const response = await axios.get(
          `${process.env.REACT_APP_API_BASE_URL}/api/StudentExam/exam-details-by-attempt/${attemptIdNum}`
        );
        
        console.log("Full API response:", response);
        console.log("Response data:", response.data);
        console.log("Response data keys:", Object.keys(response.data));

        // Debug: Check what properties are actually returned
        // The API might return different property names than expected
        const responseData = response.data;
        
        // Handle different possible property name variations
        setExamData({
          title: responseData.Title || responseData.title || "Exam",
          totalQuestions: responseData.TotalQuestions || responseData.totalQuestions || 0,
          durationMinutes: responseData.DurationMinutes || responseData.durationMinutes || 0,
          instructions: responseData.Instructions || responseData.instructions || "",
        });

        setTimeLeft(10); // 10 seconds countdown
        setLoading(false);
      } catch (error) {
        console.error("Failed to fetch exam details", error);
        if (error.response) {
          console.error("Error response:", error.response.data);
          setError(`Server error: ${error.response.status} - ${error.response.data}`);
        } else {
          setError("Failed to load exam details. Please try again.");
        }
        setLoading(false);
      }
    };

    fetchExamDetails();
  }, [attemptId]);

  // Timer countdown logic
  useEffect(() => {
    if (timeLeft === null) return;

    const timer = setInterval(() => {
      setTimeLeft(prev => {
        if (prev <= 1) {
          clearInterval(timer);
          return 0;
        }
        return prev - 1;
      });
    }, 1000);

    return () => clearInterval(timer);
  }, [timeLeft]);

  const formatTime = (seconds) => {
    const min = Math.floor(seconds / 60).toString().padStart(2, '0');
    const sec = (seconds % 60).toString().padStart(2, '0');
    return `${min}:${sec}`;
  };

  if (loading) return <div className="exam-container"><p>Loading exam instructions...</p></div>;
  if (error) return <div className="exam-container"><p className="error">{error}</p></div>;
  if (!examData) return <div className="exam-container"><p>No exam data found.</p></div>;

  return (
    <div className="exam-container">
      <div className="exam-card">
        <h2>ऑनलाईन परीक्षेच्या सूचना</h2>
        <p className="start-time">
          चाचणी सुरू होण्यास : {timeLeft !== null ? formatTime(timeLeft) : "--:--"} मिनिटे शिल्लक
        </p>
        <ol className="instructions">
          <li>एकूण प्रश्न: <strong>{examData.totalQuestions}</strong></li>
          <li>कालावधी : <strong>{examData.durationMinutes} Minutes</strong></li>
          <li>परीक्षा ऑनलाईन स्वरूपात घेण्यात येणार आहे, त्यामुळे विद्यार्थिनीं वेळेत लॉगिन करून परीक्षा द्यावी</li>
          <li>प्रत्येक प्रश्नाला चार पर्याय असतील, योग्य पर्याय निवडून क्लिक करावा.</li>
          <li>परीक्षा पूर्ण झाल्यावर "सबमिट" बटण दाबून उत्तरपत्रिका सबमिट करावी, कारण वेळ संपल्यावर ती आपोआप सबमिट होईल.</li>
          {examData.instructions && <li>{examData.instructions}</li>}
        </ol>
        <div className='Start-button'>
          <Link
            to={timeLeft === 0 ? `/ExamQuestion/${attemptId}` : "#"}
            className={`start-btn ${timeLeft === 0 ? "active" : "inactive"}`}
            onClick={(e) => {
              if (timeLeft > 0) {
                e.preventDefault();
                alert(`Please wait ${timeLeft} seconds before starting the test.`);
              }
            }}
          >
            {timeLeft === 0 ? "Start Test" : `Wait ${timeLeft}s`}
          </Link>
        </div>
      </div>
    </div>
  );
};

export default ExamInstructions;